import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type ThemeType = 'light' | 'dark';

interface SettingsState {
  theme: ThemeType;
}

// 从localStorage获取保存的主题，默认为暗色主题
const getSavedTheme = (): ThemeType => {
  const savedTheme = localStorage.getItem('theme');
  return (savedTheme as ThemeType) || 'dark';
};

// 初始状态
const initialState: SettingsState = {
  theme: getSavedTheme(),
};

// 设置文档根元素的类来应用主题
const applyTheme = (theme: ThemeType) => {
  document.documentElement.setAttribute('arco-theme', theme);
  localStorage.setItem('theme', theme);
};

// 应用初始主题
applyTheme(initialState.theme);

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<ThemeType>) => {
      state.theme = action.payload;
      applyTheme(action.payload);
    },
  },
});

export const { setTheme } = settingsSlice.actions;
export default settingsSlice.reducer; 